/**
 * PRODUCT-154 — leaf hooks over the theme reactive vars. Boot-static-safe
 * (only `@apollo/client` + the leaf `./mode`), so AntdI18n can subscribe to the
 * resolved theme without violating the PRO-130 boot-static rule.
 */
import { useReactiveVar } from '@apollo/client'

import {
  ResolvedTheme,
  resolvedThemeVar,
  ThemeMode,
  themeModeVar,
} from './mode'

export type { ResolvedTheme, ThemeMode }

export const useThemeMode = (): ThemeMode => useReactiveVar(themeModeVar)

export const useResolvedTheme = (): ResolvedTheme =>
  useReactiveVar(resolvedThemeVar)
